// Shared rows-per-page options for report pages. Extracted verbatim from the
// four report pages (Daily Attendance, Grooming, Mood, Random Attendance) that
// all declared this identical 6-entry array. Grooming additionally offers an
// "All" cap on top of these — it spreads this base and appends its own entry,
// so the base list stays in lockstep across every page.
export const PAGE_SIZE_OPTIONS: Array<{ label: string; value: number }> = [
  { label: '25 rows', value: 25 },
  { label: '50 rows', value: 50 },
  { label: '100 rows', value: 100 },
  { label: '250 rows', value: 250 },
  { label: '500 rows', value: 500 },
  { label: '1000 rows', value: 1000 },
];
